import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiElafron';
const args = {};

export class PetastiElafron extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
